
import * as domainConstants from "../../constants/DomainConstants";
import { uploadOneFile, deleteOneFile } from "../common/DownloadUploadFilesHelper";

import mergeDeep from "../../util/mergeDeep.js";
import showToastr, { showToastrSuccess, showToastrError, showToastrInfo } from "../../util/toastr.js";
import { getStore } from "../../store/configureStore";


const MAX_CHECKBOXES_CHECKED = 2;


function hasFilesForDossierComponent(documenten, component) {
	if (documenten) {
		const files = documenten.find(x => x.name === component) ? documenten.find(x => x.name === component).files : [];
		if (files) {
			return files.length > 0 ? true : false;
		}
	}
	return false;
}

export default class BeoordelingscriteriaBovenlokaalPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	receiveProps(nextProps) {
		if (this.context.props.beoordelingscriteria !== nextProps.beoordelingscriteria) {
			if (nextProps.beoordelingscriteria.tabTitel) {
				this.context.props.loadLayout(nextProps.beoordelingscriteria.naam, nextProps.beoordelingscriteria.tabTitel, nextProps.dossierId, nextProps.beoordelingscriteria.typeDossier, nextProps.infrastructuurId, (nextProps.beoordelingscriteria.redenVanStatus != "121450000" && nextProps.beoordelingscriteria.redenVanStatus !== 121450000));
			}
			this.context.setState({
				beoordelingscriteria: mergeDeep({}, nextProps.beoordelingscriteria),
				titleSet: nextProps.beoordelingscriteria.tabTitel
			});
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;
		if (dossierId) {
			this.context.props.getContent(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								documenten: result.data,
								setPlannenQuestionToJa: hasFilesForDossierComponent(result.data, domainConstants.ComponentName.ArchitectPlannen)
							});
					} else {
						showToastrError("Laden van het dossier is mislukt");
						throw new Error("getContent load failed"); //Stops promise
					}
				});
		}
		this.context.props.loadCriteria(dossierId);
	}

	// ------------------------------------------------------------------------
	onChange(event) {
		const field = event.target.name;
		const beoordelingscriteria = this.context.state.beoordelingscriteria;
		beoordelingscriteria[field] = event.target.value;

		if (event.target.value === "true") {
			switch (field) {
				case "samenwerkingsVerbanden":
					beoordelingscriteria.motiveringSamenwerkingsVerbanden = "";
					break;
				case "inzakeDeRealisatieVanHetProject":
					beoordelingscriteria.motiveringRealisatieVanHetProject = "";
					break;
				case "inzakeDeExploitatieVanHetProject":
					beoordelingscriteria.motiveringExploitatieVanHetProject = "";
					break;
				case "andereSamenwerkingsverbanden":
					beoordelingscriteria.motiveringAndereSamenwerkingsverbanden = "";
					break;
			}
		}

		if (event.target.value === "false") {
			switch (field) {
				case "samenwerkingsVerbanden":
					beoordelingscriteria.inzakeDeRealisatieVanHetProject = null;
					beoordelingscriteria.omschrijvingRealisatieVanHetProject = "";
					beoordelingscriteria.inzakeDeExploitatieVanHetProject = null;
					beoordelingscriteria.omschrijvingExploitatieVanHetProject = "";
					beoordelingscriteria.andereSamenwerkingsverbanden = null;
					beoordelingscriteria.omschrijvingAndereSamenwerkingsverbanden = "";
					break;
				case "inzakeDeRealisatieVanHetProject":
					beoordelingscriteria.omschrijvingRealisatieVanHetProject = "";
					break;
				case "inzakeDeExploitatieVanHetProject":
					beoordelingscriteria.omschrijvingExploitatieVanHetProject = "";
					break;
				case "andereSamenwerkingsverbanden":
					beoordelingscriteria.omschrijvingAndereSamenwerkingsverbanden = "";
					break;
			}
		}

		return this.context.setState(
			{
				beoordelingscriteria: beoordelingscriteria,
				hasUnsavedChanges: true
			});
	}

	onCheckBoxChange(event) {
		if (this.context.state.numberOfCheckedCheckBoxes >= MAX_CHECKBOXES_CHECKED && event.target.checked)
			return;

		const field = event.target.name;
		const beoordelingscriteria = this.context.state.beoordelingscriteria;
		beoordelingscriteria[field] = event.target.checked;

		return this.context.setState(
			{
				beoordelingscriteria: beoordelingscriteria,
				hasUnsavedChanges: true,
				numberOfCheckedCheckBoxes: event.target.checked ? this.context.state.numberOfCheckedCheckBoxes + 1 : this.context.state.numberOfCheckedCheckBoxes - 1
			});
	}

	onDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneFile(this.context, this.context.props.uploadDocument, this.context.props.dossierId, domainConstants.DocumentTab.Criteria, component, file)); });
	}

	onDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneFile(this.context, this.context.props.deleteDocument, this.context.props.dossierId, domainConstants.DocumentTab.Criteria, component, fileName); });
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: true });
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	onSave(event) {
		event.preventDefault();

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, domainConstants.DocumentTab.Criteria)
				.then(result => {
					if (!result.success) {
						showToastrError(domainConstants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");

					}
				});
		}

		this.saveTheModel();
	}

	saveTheModel() {
		const modelToSave = this.context.state.beoordelingscriteria;
		modelToSave.plannenBeschikbaar = hasFilesForDossierComponent(this.context.state.documenten, domainConstants.ComponentName.ArchitectPlannen);

		modelToSave.lopendeSamenwerkingMetInter = hasFilesForDossierComponent(this.context.state.documenten, domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing);
		//else do not overwrite the property

		this.context.props.saveCriteria(this.context.state.beoordelingscriteria, this.context.state.documenten)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved)
					this.context.setState({ hasUnsavedChanges: false });
			});
	}

	onChangeBereikDoelgroep(event, i, isFuture) {
		let beoordelingscriteria = mergeDeep({}, this.context.state.beoordelingscriteria);

		const field = event.target.name;
		const value = event.target.value;

		if (field.indexOf("aantalBezoekersJaar") !== -1 && (value === null || value.toString().indexOf('.') !== -1 || value.toString().indexOf(',') !== -1 || value < 0 || value % 1 != 0))
			return;

		if (isFuture) {
			beoordelingscriteria.bereikDoelgroepenVolgende5Jaar[i][field] = value;
		}
		else {
			beoordelingscriteria.bereikDoelgroepenVorige5Jaar[i][field] = value;
		}

		return this.context.setState({
			beoordelingscriteria: beoordelingscriteria,
			hasUnsavedChanges: true
		});
	}

	onAddBereikDoelgroep(isFuture) {
		const beoordelingscriteriaId = this.context.state.beoordelingscriteria.id;
		if (beoordelingscriteriaId) {
			this.context.props.getEmptyBereikDoelgroep(beoordelingscriteriaId, isFuture)
				.then(emptyBereikDoelgroep => {
					let beoordelingscriteria = this.context.state.beoordelingscriteria;
					if (isFuture)
						beoordelingscriteria.bereikDoelgroepenVolgende5Jaar.push(emptyBereikDoelgroep);
					else
						beoordelingscriteria.bereikDoelgroepenVorige5Jaar.push(emptyBereikDoelgroep);

					return this.context.setState({
						beoordelingscriteria: beoordelingscriteria,
						hasUnsavedChanges: true
					});
				});
		}
	}

	onRemoveBereikDoelgroep(i, isFuture) {
		let beoordelingscriteria = this.context.state.beoordelingscriteria;
		if (isFuture) {
			beoordelingscriteria.bereikDoelgroepenVolgende5Jaar.splice(i, 1);
		} else {
			beoordelingscriteria.bereikDoelgroepenVorige5Jaar.splice(i, 1);
		}

		return this.context.setState({
			beoordelingscriteria: beoordelingscriteria,
			hasUnsavedChanges: true
		});
	}
}